<template>
  <div v-if="amReady">
    <app-board
      class="p-2 mb-1"
      style="border-radius: 0;"
      v-if="userProfileId != 1 && userProfileId != 9 && userProfileId != 4 && userProfileId != 16"
    >
      <span
        class="ml-3 mr-4"
        style="font-size: 9pt; text-transform: uppercase"
        >{{ formTitle || "Testing History" }}</span
      >
      <panelKeysInfo></panelKeysInfo>
    </app-board>

    <!-- Report Dialog -->
    <el-dialog
      :append-to-body="true"
      :visible.sync="reportDialogVisible"
      class=""
      title="Report Dialog"
      top="5vh"
      width="550px"
    >
      <div class="row">
        <div
          style="width: 160px;margin-left: 20px;"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <span style="font-size: 9pt">Profit Percent</span>
          <dg-text-field
            :defaultValue="reportProfitPercentage"
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="reportProfitPercentageUpdate"
            field_mark=""
            placeholder="Percentage"
          ></dg-text-field>
        </div>
        <div
          style="width: 150px; margin-top: 20px"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <el-button
            @click="downloadReport('all')"
            icon="el-icon-download"
            size="mini"
            type="success"
            >All Destinations</el-button
          >
        </div>
        <div
          style="width: 180px; margin-top: 20px"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <el-button
            @click="downloadReport('single')"
            icon="el-icon-download"
            size="mini"
            type="success"
            >Unique Destinations
          </el-button>
        </div>
      </div>
      <div class="row">
        <div
          style="width: 160px;margin-left: 20px;"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <span style="font-size: 9pt">Number of Destinations</span>
          <dg-text-field
            :defaultValue="reportProfitPercentage"
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="reportPushListNumberOfDestinationsUpdated"
            field_mark=""
            name="reportPushListNumberOfDestinations"
            placeholder="Percentage"
          ></dg-text-field>
        </div>
        <div
          style="width: 50px; margin-top: 20px"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <el-button
            @click="downloadReport('push-list')"
            icon="el-icon-download"
            size="mini"
            type="success"
            >Push List
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :visible.sync="dialogVisible"
      @close="setVendorDestinationStatus"
      class="call-test-results-dialog"
      title=""
      top="5vh"
      width="98%"
    >
      <callTestResultsTable
        :broadcastPublicId="broadcastPublicId"
        :callTestRequest="callTestRequest"
        :liveDataResults="liveDataResults"
        :numberOfCalls="number_of_calls"
        :testFinalStatus="testFinalStatus"
        v-if="dialogVisible"
      >
      </callTestResultsTable>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="vendorDestinationStatusDialogVisible"
      class="call-test-results-dialog"
      title=""
      top="4vh"
      width="300px"
    >
      <vendorDestinationStatus
        :broadcast="broadcast"
        @closeModel="closeVendorDestinationStatus"
        v-if="vendorDestinationStatusDialogVisible"
      >
      </vendorDestinationStatus>
    </el-dialog>

    <app-board
      style="border-radius: 0; margin-bottom: 5px; padding-bottom: 0px; padding-left: 20px;"
    >
      <div class="row m-0">
        <div style="width: 250px">
          <span style="font-size: 9pt"> Search </span>
          <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            class="m-0 p-0"
            field_mark=""
            placeholder="search prefix or destination"
          ></dg-text-field>
        </div>
        <div
          style="width: 180px"
          v-if="allowFilterBy && userProfileId != 9  && userProfileId != 16"
        >
          <span style="font-size: 9pt"> Filter</span>
          <dg-select-field
            :field_span="22"
            :label_span="22"
            :defaultValue="defaultFilterValue"
            :options="filterOptions"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="filterOptionsUpdated"
            field_mark=""
            label=""
            name="filterOption"
            placeholder="Select Status"
            rules=""
          ></dg-select-field>
        </div>
        <div
          style="width: 150px"
          v-if="allowFilterBy && !singleAutomationTestHistory"
        >
          <span style="font-size: 9pt"> Division</span>
          <dg-select-field
            :field_span="22"
            :label_span="22"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark=""
            label=""
            name="filterByDivision"
            placeholder="select division"
            rules=""
            valueProperty="label_2"
          ></dg-select-field>
        </div>
        <div style="width: 250px">
          <span style="font-size: 9pt"> Search ANI</span>
          <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="aniUpdated"
            class="m-0 p-0"
            field_mark=""
            placeholder="search ANI"
          ></dg-text-field>
        </div>
        <div
          style="width: 90px"
          v-if="
            allowFilterBy && callsStatusToView != 0 && selectedFilterDivision
          "
        >
          <el-button
            class="mt-4"
            @click="reportDialogVisible = true"
            icon="el-icon-folder"
            size="mini"
            type="primary"
            >Report Dialog
          </el-button>
        </div>
        <div style="width: 500px" v-if="!allowFilterBy" class="mt-3">
          <pagination
            :currentPage="currentPage"
            :margin-pages="4"
            :navigateHandler="navigateToPage"
            :page-count="Math.ceil(recordsCounter / pageChunkSize)"
            :page-range="6"
            class="d-inline-block"
            paginateClass=""
            style="margin-left: -15px;"
          ></pagination>
        </div>
      </div>
      <div class="row m-0" v-if="allowFilterBy">
        <div :class="'col-12 ' + allowFilterBy ? 'col-md-12' : 'col-md-12'">
          <pagination
            :currentPage="currentPage"
            :margin-pages="4"
            :navigateHandler="navigateToPage"
            :page-count="Math.ceil(recordsCounter / pageChunkSize)"
            :page-range="6"
            class="d-inline-block"
            paginateClass=""
            style="margin-left: -15px;"
          ></pagination>
          <span style="display: inline-block;margin: 0 20px;">
            <small>Total Records: {{ recordsCounter }}</small> |
            <small> {{ pageChunkSize }} record per page</small>
          </span>
        </div>
      </div>
    </app-board>

    <app-board style="border-radius: 0; margin-bottom: 5px">
      <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </app-board>
  </div>
</template>

<script>
import agGridButton from "@/components/ag-grid-button/View";
import callTestStatusViewer from "@/components/call-test-status-viewer/View";

import module from "./../../index.js";
import { notify } from "@/system-services/notify.js";

import { getLS } from "devegram-javascript-util";
import panelMixin from "@/app/portals/cpanel/mixins/util";
import setVendorStatusMixin from "@/app/portals/cpanel/mixins/setVendorStatus";

export default {
  mixins: [panelMixin, setVendorStatusMixin],
  components: {
    panelKeysInfo: () =>
      import("@/components/system-table-keys-info/TestingHistory"),
    callTestResultsTable: () =>
      import("@/components/call-test-results-table/View"),
    pagination: () => import("@/components/pagination/View.vue"),
    vendorDestinationStatus: () =>
      import("./../../vendor-destination-status/View"),
    // callTestResults: () => import('./../../call-test-results/View'),
    // moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    singleAutomationTestHistory: {
      required: false,
      default: false,
    },
    get_automation: {
      required: false,
      default: 0,
    },
    verified: {
      required: false,
      default: 0,
    },
    get_automation_without_action: {
      required: false,
      default: 0,
    },
    showAllTests: {
      default: false,
    },
    formTitle: {
      required: false,
      default: "",
    },
    userId: {
      default: false,
    },
    statusId: {
      type: Number,
    },
    allowFilterBy: {
      default: false,
    },
  },
  data() {
    return {
      defaultFilterValue: 0,
      selectedReportPushListNumberOfDestinations: 20,
      reportDialogVisible: false,
      reportProfitPercentage: 20,
      userProfileId: $store.state["user-state"].profile.profile_id,
      selectedFilterDivision: "",
      filterOptionsCustom: [
        {
          label: "Working",
          value: "2",
        },
      ],
      filterOptions: [
        {
          label: "All",
          value: "0",
        },
        {
          label: "Working",
          value: "2",
        },
        {
          label: "FAS",
          value: "3",
        },
        {
          label: "Awaiting Action",
          value: "1",
        },
        {
          label: "Unconnected",
          value: "4",
        },

        {
          label: "Verified",
          value: "6",
        },
        {
          label: "Requires Test",
          value: "5",
        },
      ],
      selectedFilterOption: "",
      isUserRoot: $store.getters["user-state/isUserRoot"],
      testFinalStatus: 0,
      number_of_calls: -1,
      isUserCustomerOrReseller:
        $store.getters["user-state/isUserCustomer"] ||
        $store.getters["user-state/isUserReseller"],
      defaultRouteDivision: this.$route.params.division,
      isUserReseller: $store.getters["user-state/isUserReseller"],
      isUserCustomer: $store.getters["user-state/isUserCustomer"],
      broadcastPublicId: null,
      callsStatusToView: 0,
      amReady: false,
      broadcast: null,
      callTestRequest: {},
      liveDataResults: [],
      module: {
        ...module,
      },
      userSearch: "",
      aniSearch: "",
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      vendorDestinationStatusDialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        rowClassRules: {
          "app-bg-gold-low-alfa": function(params) {
            return (
              params.data.is_automated == "1" &&
              params.data.status == "3" &&
              (params.data.action_taken_by == "<AUTOMATION>" ||
                params.data.action_taken_by == "<AUTOMATION NO ACTION>")
            );
          },
          "app-bg-green-low-alfa": function(params) {
            return params.data.is_today == "1" && params.is_automated == "0";
          },
        },
        pagination: false,
        enableRtl: this.$langConfig.dir == "rtl",
        agGridStyle: "width: 100%; height: 650px; padding: 0",
        agGridClass: "ag-theme-material",
        gridOptions: {
          suppressHorizontalScroll: false,
          suppressCellSelection: true,
          onGridReady: function(params) {
            params.api.sizeColumnsToFit();
          },
        },
        columnDefs: [
          {
            field: "prefix",
            headerName: "Prefix",
            filter: false,
            minWidth: 80,
            headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
            autoHeight: true,
          },
          {
            field: "destination",
            minWidth: 120,
            filter: false,
            headerName: "Destination",
            headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
            autoHeight: true,
          },
          {
            field: "dialcode",
            minWidth: 70,
            sortable: false,
            filter: false,
            headerName: "Code",
            headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
            autoHeight: true,
          },

          {
            field: "rate",
            minWidth: 80,
            filter: false,
            headerName: "Rate",
            headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
            autoHeight: true,
          },
          {
            field: "execution_time",
            minWidth: 100,
            headerName: "Time",
            filter: false,
            headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
            autoHeight: true,
          },
        ],
        rowData: [],
      },
    };
  },
  beforeMount() {
    this.currentUser = getLS("user").profile_id;

    if (this.isUserRoot) {
      /*this.agGrid.columnDefs.push({
        field: 'is_root',
        minWidth: 60,
        filter: false,
        headerName: 'Root',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true
      })*/
    }

    if (!this.isUserCustomer && !this.isUserReseller) {
      this.agGrid.columnDefs.push({
        field: "caller_id",
        minWidth: 80,
        headerName: "ANI",
        filter: false,
        headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
        autoHeight: true,
      });

      this.agGrid.columnDefs.push({
        field: "division_name",
        minWidth: 80,
        headerName: "Division",
        filter: false,
        headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
        autoHeight: true,
      });

      this.agGrid.columnDefs.push({
        field: "created_by",
        minWidth: 80,
        headerName: "Created By",
        filter: false,
        headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
        autoHeight: true,
      });

      this.agGrid.columnDefs.push({
        field: "action_taken_by",
        minWidth: 80,
        headerName: "Action By",
        filter: false,
        headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
        autoHeight: true,
      });

      this.agGrid.columnDefs.push({
        field: "status",
        minWidth: "80",
        headerName: "Status",
        headerClass: this.$langConfig.lang + "-lang-text text-capitalize",
        autoHeight: true,
        filter: false,
        cellClass: "p-0",
        cellRendererFramework: $vue.extend(callTestStatusViewer),
        cellRendererParams: {
          props: {
            actionsHandler: this.actionsHandler,
          },
        },
      });

      /*if (this.get_automation) {
        this.agGrid.columnDefs.push({
          field: 'is_automated',
          minWidth: 50,
          headerName: 'Auto',
          filter: false,
          headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
          autoHeight: true,
          cellRenderer: (params) => {
            return (params.data.is_automated == 1) ? "Yes" : "No";
          }
        })
      }*/
    }

    this.agGrid.columnDefs.push({
      width: 160,
      filter: false,
      headerName: "View",
      headerClass: "text-capitalize text-center",
      cellClass: "text-center",
      cellRendererFramework: $vue.extend(agGridButton),
      cellRendererParams: {
        props: {
          action: this.viewCallTestResults,
          icon: "el-icon-view",
          text: "",
          style: "",
        },
      },
    });

    if (this.allowFilterBy && this.statusId)
      this.defaultFilterValue = this.statusId + "";

    this.callsStatusToView = this.statusId;
    this.currentPage = 1; // parseInt(this.$route.params.listPage)

    this.panelMixin_getUserVoipDivision("divisionsList", (r) => {
      for (let d in r) {
        if (r[d].label == this.defaultRouteDivision) {
          this.defaultRouteDivision = r[d].label_2;
        }
      }

      this.getEntityListData(this.currentPage);
      this.amReady = true;
    });
  },
  methods: {
    reportPushListNumberOfDestinationsUpdated(inputField) {
      let val = inputField.field.field_value;
      this.selectedReportPushListNumberOfDestinations = val;
    },
    reportProfitPercentageUpdate(inputField) {
      let val = inputField.field.field_value;
      this.reportProfitPercentage = val;
    },
    downloadReport(downloadMode) {
      this.downloadBroadcastReport({
        status: this.callsStatusToView,
        divisionLabel: this.selectedFilterDivision,
        percentage: this.reportProfitPercentage,
        pushListNumberOfDestinations: this
          .selectedReportPushListNumberOfDestinations,
        downloadMode: downloadMode,
      });
    },
    divisionUpdated(inputField) {
      let val = inputField.field.field_value;
      this.selectedFilterDivision = val;
      this.getEntityListData(1);
    },
    filterOptionsUpdated(inputField) {
      let val = inputField.field.field_value;
      this.callsStatusToView = val;
      this.getEntityListData(1);
    },
    getEntityListData(page) {
      if (this.singleAutomationTestHistory) {
        /*let statusId = this.callsStatusToView
        let divisionId = (this.singleAutomationTestHistory.hasOwnProperty('division_id'))? this.singleAutomationTestHistory.division_id : ''
        let search = (this.singleAutomationTestHistory.hasOwnProperty('search'))? this.singleAutomationTestHistory.search : ''
        let automationTestId = this.singleAutomationTestHistory.id*/

        this.getAutomationTestHistory({
          page: page,
          statusId: this.callsStatusToView,
          divisionId: "",
          search: this.userSearch,
          automation_test_id: this.singleAutomationTestHistory,
        }).then((r) => {
          this.buildAgGridData(r);
        });
      } else {
        this.panelMixin_getBroadcastHistory(
          {
            page: page,
            search: this.userSearch,
            aniSearch: this.aniSearch,
            userId: this.getUser(),
            isVerified : this.verified,
            statusId: this.callsStatusToView,
            division: this.selectedFilterDivision
              ? this.selectedFilterDivision
              : this.defaultRouteDivision,
            showAll: this.showAllTests ? 1 : 0,
            get_automation: this.get_automation,
            get_automation_without_action: this.get_automation_without_action,
          },
          (response) => {
            this.buildAgGridData(response);
          }
        );
      }
      this.currentPage = page;
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.data.rows;
      this.recordsCounter = response.data.count;
      this.amReady = true;
    },
    userSearchUpdated(field) {
      let val = field.field.field_value;
      this.userSearch = val;
      clearTimeout(this.userSearchTimeOut);
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1); //this.agGrid.gridApi.setQuickFilter(val);
      }, 200);
    },
    aniUpdated(field) {
      let val = field.field.field_value;
      this.aniSearch = val;
      clearTimeout(this.userSearchTimeOut);
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1); //this.agGrid.gridApi.setQuickFilter(val);
      }, 200);
    },
    getUser() {
      let userId = this.userId;
      return this.userId ? this.userId : "";
      // /*if (!userId) {
      //   userId = getLS('user').id
      // }
      // return userId*/
      return "";
    },
    isVerified() {
      let profile_id = getLS("user").profile_id;
      
      return profile_id ==9 ? 1 : "";
    },
    closeVendorDestinationStatus(newStatus) {
      this.vendorDestinationStatusDialogVisible = false;
      let s = this.broadcast.status;
      // if (s == 1 || (s == 3 && this.broadcast.is_automated == 1) && (newStatus != s || (newStatus == s && this.broadcast.is_automated))) {
      /*if (s == 1 || (s == 3 && this.broadcast.is_automated == 1) && (newStatus != s )) {
        this.agGrid.rowData.splice(this.rowToEdit, 1);
      }*/
      this.navigateToPage(this.currentPage);
    },
    ...$mapActions("voip-testing-panel-state", ["getEntityRecords"]),
    ...$mapActions("voip-testing-panel-api", {
      getBroadcastCdr: "getBroadcastCdr",
      getAutomationTestHistory: "getAutomationTestHistory",
      downloadBroadcastReport: "downloadBroadcastReport",
    }),
    viewCallTestResults(data, props, rowIndex) {
      this.rowToEdit = rowIndex;
      this.broadcast = data;
      this.liveDataResults = [];
      this.broadcastPublicId = data.public_id;
      this.showLiveResults(this.broadcast.id);
      this.dialogVisible = true;
    },
    showLiveResults(broadcastId) {
      this.getBroadcastCdr({ id: broadcastId }).then((response) => {
        let cdr = response.data;

        this.callTestRequest = cdr;
        this.liveDataResults = JSON.parse(cdr.cdr_json);
        this.number_of_calls = cdr.number_of_calls;
        this.testFinalStatus = cdr.system_call_test_status_id;
      });
    },
    setVendorDestinationStatus() {
      this.vendorDestinationStatusDialogVisible = this._canSetBroadcastStatus(
        this.broadcast
      );
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById("content-main-container").scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize);
    },
    navigateToPage(page) {
      this.getEntityListData(page);
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData);
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store
        .dispatch(this.module.info.name + "-api/remove", { id: params.data.id })
        .then((response) => {
          this.agGrid.rowData.splice(params.rowIndex, 1);
          this.refreshGrid();
          this.recordsCounter -= 1;
          notify({
            type: "success",
            title: this.$ml.get("deleted"),
          });
        });
    },
    actionsHandler(command, params) {
      this[command](params);
    },
  },
};
</script>
